import * as React from 'react';
import {Grid, Popover, Typography} from '@material-ui/core';
import {Create, SimpleForm, SimpleFormOnlySaveToolbar} from '../../controlComponents';
import {useTranslation} from 'react-i18next';
import {withStyles} from '@material-ui/styles';
import {compose, Dispatch} from 'redux';
import {reset} from 'redux-form';
import {connect} from 'react-redux';
import {PopoverHandleCloseFunction} from './index';

const form = 'list-create-form';

const styles = {
    title: {
        fontSize: 20,
    },
    root: {
        width: '15vw',
    },
    toolbar: {
        paddingLeft: 0,
    },
};

interface Props {
    open: boolean;
    handleClose: PopoverHandleCloseFunction;
    fields: Array<Element>;
    resource: string;
    anchorEl: Element | null;
    classes?: Record<string, string>;
    dispatch: Dispatch;
}

const ListCreatePopover: React.FunctionComponent<Props> =
    ({open, handleClose, anchorEl, classes, dispatch, resource, fields}) => {
        const {t: translate} = useTranslation();
        const formName = `${form}-${resource}`;
        return (
            <Popover
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                anchorEl={anchorEl}
            >
                <div className={classes?.root}>
                    <Create resource={resource}>
                        <SimpleForm
                            resource={resource}
                            form={formName}
                            afterSubmit={(): void => {
                                handleClose({}, 'backdropClick');
                                dispatch(reset(formName));
                            }}
                            toolbar={<SimpleFormOnlySaveToolbar toolbarClassName={classes?.toolbar} />}
                        >
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography className={classes?.title}>
                                        {translate('common.actions.create')}
                                    </Typography>
                                </Grid>
                                {React.Children.map(fields, (child) => (
                                    <Grid item xs={12}>
                                        {child}
                                    </Grid>
                                ))}
                            </Grid>
                        </SimpleForm>
                    </Create>
                </div>
            </Popover>
        );
    };

const EnhancedListCreatePopover = compose(
    connect(null, null),
    withStyles(styles)
)(ListCreatePopover);

export default EnhancedListCreatePopover;